// モックの showScreen() は画面切り替えのたびに window.scrollTo(0,0) していた。
// モーダル実装ではスクロールするのはオーバーレイ要素なので、そちらをリセットする。
export function scrollModalToTop(): void {
  const overlay = document.querySelector<HTMLElement>('.organization_assessment_overlay')
  if (overlay) overlay.scrollTop = 0
}

// 設問に回答したときに、次の設問までユーザーの代わりにスクロールする。
export function scrollElementIntoView(el: HTMLElement): void {
  el.scrollIntoView({ behavior: 'smooth', block: 'center' })
}
